import React, { useState, useEffect, useContext } from 'react';
import { withStyles, Button } from '@material-ui/core';
// import eruda from 'eruda';

const styles = (theme) => ({
  DeliveryIntro: {
    backgroundColor: '#fff',
    position: 'fixed',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    zIndex: '100000',
  },
  mainBox: {
    width: '100%',
    height: '100%',
    position: 'relative',
    paddingTop: '18.75rem',
    paddingBottom: '6.25rem',
  },
  introBox: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: 'auto',
    padding: '2.25rem 1.25rem 0',
  },
  termBox: {
    height: '100%',
    overflow: 'hidden',
    padding: '0.7188rem 1.25rem 0',
  },
  termContent: {
    height: '100%',
    overflowY: 'auto',
    position: 'relative',
    paddingBottom: '3.125rem',
  },
  warnIcon: {
    width: '2.625rem',
    height: '2.625rem',
    border: 'solid 0.1125rem #000',
    backgroundColor: theme.color.button.background_white,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    fontSize: theme.font.size26,
    color: theme.color.button.background_red,
    fontWeight: 'bold',
    lineHeight: '1.88',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    margin: '0 0 1.5rem 0',
  },
  title1: {
    paddingTop: '0.625rem',
    fontFamily: 'inherit',
    fontSize: '1.5rem',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.5',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
  },
  title2: {
    fontFamily: 'inherit',
    fontSize: '1.625rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.38',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#ea1917', //"#da0f47",
  },
  titlePlain: {
    color: '#000',
  },
  desc: {
    alignItems: 'flex-start',
    textAlign: 'left',
    fontFamily: 'inherit',
    fontSize: '1rem',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.57',
    letterSpacing: 'normal',
    color: '#000',
    marginTop: '0.625rem',
  },
  termTitle: {
    fontSize: '0.875rem',
    fontWeight: 'bold',
    lineHeight: '1.29',
    color: 'black',
  },
  termHr: {
    height: '1px',
    backgroundColor: '#ddd',
    marginBottom: '0.7188rem',
    width: '100%',
  },
  btnStart: {
    padding: '0.875rem 1.25rem 2.25rem 1.25rem',
    position: 'fixed',
    bottom: '0',
    width: '100%',
    height: '6.25rem',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  button: {
    width: '100%',
    minHeight: '3.125rem',
    backgroundColor: theme.color.button.background_red,
    color: theme.color.button.text_white,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    padding: '0.9375rem 0',
    borderRadius: '0.375rem',
  },
});

function DeliveryIntro(props) {
  const { classes, setIntroResult } = props;
  const [termsHtml, setTermsHtml] = useState('');

  // 모바일에서 개발자도구 사용 https://github.com/liriliri/eruda
  // eslint-disable-next-line no-restricted-globals
  // const url = location.href;
  // const isNotProd = url.indexOf('chat.lge') < 0 ? true : false;

  // if (isNotProd) {
  //   eruda.init();
  // }

  const handleButton = () => {
    setIntroResult('chatbot');
  };
  const title1 = '안녕하세요 고객님!';
  const title2 = 'LG전자 상담 챗봇';
  const title3 = '입니다.';
  const desc1 = '고객님의 배송 정보 확인을 위한';
  const desc2 = '약관을 동의해주세요.';

  useEffect(() => {
    async function getTerms() {
      let response = await fetch('/ext/terms/delivery_terms_kr.html');
      // let response = await fetch('/ext/reservation/html/terms/terms_3_kr.html');
      let term_text = await response.text();
      setTermsHtml(term_text);
    }
    getTerms();
  }, []);

  return (
    <div className={classes.DeliveryIntro}>
      <div className={classes.mainBox}>
        <div className={classes.introBox}>
          <img
            src="/image/chatbot_robot.webp"
            srcSet="/image/chatbot_robot@2x.webp 2x,
                      /image/chatbot_robot@3x.webp 3x"
            className={classes.chatbotRobot}
          />
          <div className={classes.title1}>{title1}</div>
          <div className={classes.title2}>
            {title2}
            <span className={classes.titlePlain}>{title3}</span>
          </div>
          <div className={classes.desc}>
            {desc1}
            <br />
            {desc2}
          </div>
        </div>
        <div className={classes.termBox}>
          <div className={classes.termTitle}>개인정보 수집 및 이용 동의</div>
          <hr className={classes.termHr} />
          <div
            className={classes.termContent}
            dangerouslySetInnerHTML={{ __html: termsHtml }}
          />
        </div>
        <div className={classes.btnStart}>
          <Button type="button" className={classes.button} onClick={handleButton}>
            동의하고 시작하기
          </Button>
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(DeliveryIntro);
